import React from "react";
import DatePicker from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";

export default function DatePickerInner (props) {

    const [startDate, setStartDate] = React.useState(new Date());
    const ExampleCustomInput = ({ value, onClick }) => (
      <div style={{width: '300px', height: '40px', border: '1px solid black', lineHeight: '40px', paddingLeft: '10px', background: '#ffffff', borderTop: 0, borderLeft: 0, borderRight: 0, borderBottom: '1px solid darkgrey', backgroundColor: '#EEEEEE', ...props.inputStyle}} onClick={onClick}>
        {value ? value : props.placeholder}
      </div>
    );

    return (
      <DatePicker
        selected={props.selected != undefined ? props.selected : startDate}
        timeIntervals={15}
        dateFormat="dd-MM-yyyy"
        readOnly={props.readOnly ? props.readOnly : false}
        onChange={date => {
          setStartDate(date)
          props.onChange (date);
        }}
        customInput={<ExampleCustomInput />}
      />
    );
  };
